import vue from 'vue'
import axios from './axios'
import {ONLINEHOST_EMOF, SZST_URL} from "@/config";

// 全局接口
const apiContent = {
  // 帐号登录
  login: (data) => {
    return axios('/Home/Index/Login', data)
  },
  //  快捷登录
  login2: (data) => {
    return axios('/Home/Index/sms_login', data)
  },
  //  获取验证码
  getCode: (data) => {
    return axios('/Home/Index/sms_send', data)
  },
  //  注册
  register: (data) => {
    return axios('/Home/Index/sms_reg', data)
  },
  BinDingphone: (data) => {
    return axios('/Home/Index/BinDingphone', data)
  },
  //  忘记密码 ...
  setPass: (data) => {
    return axios('', data)
  },
  //  获取我添加的知识库
  GetAllList: (data) => {
    return axios('/Home/zhishiku/GetAllList', data)
  },
  //  添加知识库
  addZsk: (data) => {
    return axios('/Home/zhishiku/add', data)
  },
  //修改知识库
  editZsk: (data) => {
    return axios('/Home/zhishiku/edit', data)
  },
  //删除知识库
  deleteZsk: (data) => {
    return axios('/Home/zhishiku/del', data)
  },
  //  获取左侧单个知识库的栏目导航
  GetFolderList: (data) => {
    return axios('/Home/Folder/GetFolderList', data)
  },

  //  获取当前文件夹下的资源
  GetOneFolderList: (data) => {
    return axios('/Home/Folder/GetOneFolderList', data)
  },
  //  上传文件后回调
  addFile: (data) => {
    return axios('/Home/File/addFile', data)
  },
  //  创建文件夹
  AddFolder: (data) => {
    return axios('/Home/Folder/AddFolder', data)
  },
  //  当前导航所在位置
  NowTab: (data) => {
    return axios('/Home/Folder/NowTab', data)
  },

  //  获取文件详情
  getFileDetail: (data) => {
    return axios('/Home/File/FileView', data)
  },
  //  删除文件或文件夹
  DelFolder: (data) => {
    return axios('/Home/Folder/DelFolder', data)
  },
  //  库回收站列表
  Recycled: (data) => {
    return axios('/Home/Folder/Recycled', data)
  },
  //  恢复文件
  regain: (data) => {
    return axios('/Home/Folder/regain', data)
  },
  //  帮助中心列表、消息中心列表
  GetHelpinfo: (data) => {
    return axios('/Home/Article/GetHelpinfo', data)
  },
  //全局搜索
  Search: (data) => {
    return axios('/Home/File/Search', data)
  },
  //  帐号升级
  shengji: (data) => {
    return axios('/Home/Upgrade/shengji', data)
  },
  //  获取个人信息
  Getinfo: (data) => {
    return axios('/Home/User/Getinfo', data)
  },
  // 上传头像
  Thumb: (data) => {
    return axios('/Home/User/Thumb', data)
  },
  //  更换手机号
  Changephone: (data) => {
    return axios('/Home/User/Changephone', data)
  },
  //  修改密码
  ChangePass: (data) => {
    return axios('/Home/User/ChangePass', data)
  },
  //  修改文件夹名称
  EditFolder: (data) => {
    return axios('/home/folder/EditFolder', data)
  },
  //  只获取单个库的文件夹列表
  GetOnlyFolderList: (data) => {
    return axios('/Home/Folder/GetOnlyFolderList', data)
  },
  //  移动文件夹到其他知识库
  Moveku: (data) => {
    return axios('/Home/Folder/Moveku', data)
  },
  //  获取知识库共享的人员列表
  GetOneKuCheck: (data) => {
    return axios('/Home/Team/GetOneKuCheck', data)
  },
  //  团队人员列表
  GetUser: (data) => {
    return axios('/Home/Team/GetUser', data)
  },
  //  知识库添加共享人员
  AddShare: (data) => {
    return axios('/Home/Team/AddShare', data)
  },
  //  保存个人信息
  Editinfo: (data) => {
    return axios('/Home/User/Editinfo', data)
  },
  //  解绑微信
  DelWechat: (data) => {
    return axios('/Home/Upgrade/DelWechat', data)
  },
  //  微信登录
  wxlogin: (data) => {
    return axios('/home/Index/wx_login', data)
  },
  // 上传图片
  file2: (data) => {
    return axios('http://upload-z2.qiniup.com/', data, 'post', false)
  },
  //  上传文件夹信息
  Uploadmore: (data) => {
    return axios('/home/File/Uploadmore', data)
  },
  //  获取益书宝树状结构图
  GetTree: (data) => {
    return axios('/home/Api/GetTree', data)
  },
  Export: (data) => {
    return axios('/home/Api/Export', data)
  },
  //排序接口
  Ranking: (data) => {
    return axios('/Home/zhishiku/Ranking', data)
  },
  // 单点登录
  loginAutoByCookie: (data) => {
    return axios('/home/index/Synchronouslogin', data)
  },
  //  获取益会宝树状图
  YhbGetTree: (data) => {
    return axios('/home/Api/YhbGetTree', data)
  },
  //  益宣宝
  YxbGetTree: (data) => {
    return axios('/home/Api/YxbGetTree', data)
  },
  SuanGetTree: (data) => {
    return axios('/home/Api/SuanGetTree', data)
  },
  //  益会宝导入
  YhbExportMore: (data) => {
    return axios('/home/Api/YhbExportMore', data)
  },
  //  益宣宝导入
  YxbExportMore: (data) => {
    return axios('/home/Api/YxbExportMore', data)
  },
  //  益算宝导入
  SuanexportToEmof: (data) => {
    return axios('/home/Api/SuanexportToEmof', data)
  },
  //知识管理提交申请
  organizationApplyYXB: (data) => {
    return axios('/home/api/ApplyOrg', data)
  },
  //  检测文件夹重名
  checktitle: (data) => {
    return axios('/Home/Folder/checktitle', data)
  },
  //  添加合同
  addOrUpdateContract: (data) => {
    return axios('/home/Contract/addOrUpdateContract', data)
  },
  //  删除合同
  delContract: (data) => {
    return axios('/home/Contract/delContract', data)
  },
  //  合同详情
  showContract: (data) => {
    return axios('/home/Contract/showContract', data)
  },
  //  合同列表
  contractList: (data) => {
    return axios('/home/Contract/contractList', data)
  },
  //  合同付款约定的列表
  contractPayAppointmentList: (data) => {
    return axios('/Home/Contract/contractPayAppointmentList', data)
  },
  //  添加 或 修改 合同付款约定
  addOrUpdateContractPayAppointment: (data) => {
    return axios('/home/Contract/addOrUpdateContractPayAppointment', data)
  },
  //  删除 合同付款约定
  contractPayAppointmentDelete: (data) => {
    return axios('/home/Contract/contractPayAppointmentDelete', data)
  },
  //  合同修改记录
  contractLogList: (data) => {
    return axios('/home/Contract/contractLogList', data)
  },

  //  合同统计
  contractStatistics: (data) => {
    return axios('/home/Contract/contractStatistics', data)
  },

  getAgreement: (data) => {
    return axios(SZST_URL + 'api/index/agreement', data)
  },
  feedback: (data) => {
    return axios(ONLINEHOST_EMOF + 'home/index/feedback', data)
  },

}

const api = {
  apiContent,
}
vue.prototype.$api = api
